<template>
    <div class="container">
        <div class="container">
            <h2 class="title">404</h2>
            <img src="../assets/images/nonentity.png"
                 alt="">
        </div>
    </div>
</template>

<script>
export default {
    // 组件
    components: {},
    props: {},
    data () {
        return {};
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {},
    // 创建完成
    created () {
    },
    // 挂载完成
    mounted () {

    },
    // 销毁之前
    beforeDestroy () {
    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title {
        height: 80px;
        font-size: 26px;
        color: #b5bad2;
    }
}
</style>